import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { SharedModule } from '@shared/shared.module';

import { ComboboxComponent } from './combobox.component';

@NgModule({
	declarations: [ComboboxComponent],
	imports: [
		CommonModule,
		FormsModule,
		ReactiveFormsModule,
		SharedModule
	],
	exports: [ComboboxComponent],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ComboboxModule { }
